<template>
  <v-layout>
    <v-btn-toggle
      v-for="(group, i) in config"
      :key="`pb-d-filter-${group.type}`"
      :class="{ 'ml-3': i > 0 }"
    >
      <v-btn
        v-for="filter in group.filters"
        :key="`pb-d-filter-group-${filter}`"
        :color="checkFilterSelection(group.type, filter) ? 'success' : noValueBtnColor"
        class="pb-dashboard-filter-activator"
        depressed
        small
        @click="setFilter(group.type, filter)"
      >
        {{ filter }}
        <span v-if="itemsCountByFilter[filter]">
          ({{ itemsCountByFilter[filter] }})
        </span>
      </v-btn>
    </v-btn-toggle>
  </v-layout>
</template>

<script>
// This is a temporary solution until the backend introduces filters
const DEFAULT_FILTERS = {
  SHIPPING_PERIODS: ['Yesterday', 'Today', 'Tomorrow'],
  PROFIT: ['RUSH'],
};

const EMIT_EVENTS_BY_FILTER_TYPE = {
  profit: 'change:profit',
  shippingPeriods: 'change:shipping-periods',
};

export default {
  name: 'PbDashboardFilters',

  props: {
    profit: {
      type: Array,
      required: true,
    },

    shippingPeriods: {
      type: Array,
      required: true,
    },

    itemsCountByFilter: {
      type: Object,
      required: true,
    },
  },

  computed: {
    config() {
      return [
        { type: 'profit', filters: DEFAULT_FILTERS.PROFIT },
        { type: 'shippingPeriods', filters: DEFAULT_FILTERS.SHIPPING_PERIODS },
      ];
    },

    noValueBtnColor() {
      return this.$vuetify.theme.dark ? '#1e1e1e' : '#fff';
    },
  },

  methods: {
    setFilter(type, value) {
      this.$emit(
        EMIT_EVENTS_BY_FILTER_TYPE[type],
        this[type].includes(value)
          ? this[type].filter(v => v !== value)
          : [...this[type], value],
      );
    },

    checkFilterSelection(type, value) {
      return this[type].includes(value);
    },
  },
};
</script>

<style lang="css" scoped>
.pb-dashboard-filter-activator {
  border: none !important;
}

.pb-dashboard-filter-activator:first-child {
  border-top-left-radius: 4px !important;
}

.pb-dashboard-filter-activator:last-child {
  border-top-right-radius: 4px !important;
}

.pb-dashboard-filter-activator {
  opacity: 1 !important;
}

.pb-dashboard-filter-activator:before {
  opacity: 0 !important;
}

</style>
